import React, { useState, useEffect } from 'react'
import { generateInputField } from '../factory'
import ECreateToolbar from './ECreateToolbar'
import { useMediaQuery, Grid, Box, Typography } from '@mui/material'

import { useRecordContext, useResourceContext} from 'react-admin'
import queryString from 'query-string';
import { useTranslate, SimpleForm, Labeled } from 'react-admin'
import { useFormContext } from 'react-hook-form';



const labeledFields = [
  "reference_text_new_disabled",
  "date_time_field",
  "select_field",
  "text_field",
  "richtext_field",
  "attachment_preview",
  "show_location",
  "date_time_field",
  "date_field",
  "show_location",
  "select_create_field_depend",
  "field_full_text_search_depend",
  "advanced_select_show"
];

const renderFields = (props, filteredFields, translate, resource) => {
  return (
    <Grid container sx={{ flexGrow: 1 }}  columnSpacing={2}
    
    >
      {filteredFields.map((f, innerIndex) => (
        <React.Fragment key={innerIndex}>
          {f.is_require_separator && <Box width="100%" />}
          {f.is_require_label && (
            <>
              <Typography variant="h6" gutterBottom>
                {f.label_text}
              </Typography>
              <Box width="100%" />
            </>
          )}
          <Grid
            {...props}
            item
            size={{
              xs: f.grid_xs || 4,
              sm: f.grid_sm || 4
            }} 
                     >
            <Box
              sx={{
                borderRadius: "8px",
                padding: "10px",
                marginBottom: "8px",
                backgroundColor: "#fff",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
              }}
            >
              {labeledFields.includes(f.input_widget_type) ? (
                <Labeled
                  sx={{
                    "& .RaLabeled-label": {
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: "#000",
                      paddingBottom: "5px",
                      display: "block",
                    },
                  }}
                >
                  {generateInputField(f, innerIndex, props.id)}
                </Labeled>
              ) : (
                generateInputField(f, innerIndex, props.id)
              )}
            </Box>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};





/* const DebugErrors = () => {
  const { formState } = useFormContext();
  console.log('errors:', formState.errors); // watch console
  return null;
}; */
const Form = ({ resourcesTabs, initValues, filteredFields, ...props }) => {
  const [isDefaultValue, setIsDefaultValue] = useState(false);
  const [redirect, setRedirect] = useState('list');
  const [keyValue, setKeyValue] = useState(null);
  const [keyName, setKeyName] = useState(null);
  const [backTo, setBackTo] = useState(null);
  const [defaultFilterValue, setDefaultFilterValue] = useState(null);
  const [tab, setTab] = useState('');

  useEffect(() => {
    const {
      addShortCut: addShortCutString,
      keyValue: keyValueString,
      keyName: keyNameString,
      backTo: backToString,
      tab: tabString,
    } = queryString.parse(window.location.hash);

    if (addShortCutString === 'true') {
      setIsDefaultValue(true);
      setKeyValue(keyValueString || '');
      setKeyName(keyNameString || '');
      setBackTo(backToString || '');
      setTab(tabString || '');

      if (keyValue && backTo) {
        setRedirect(`/${backTo}/${keyValue}/${tab}`);
        setDefaultFilterValue({ [keyName]: keyValue });
      }
    }
  }, []);

  const translate = useTranslate();
  const resource = useResourceContext();

  return (
    <SimpleForm
      {...props}

      defaultValue={isDefaultValue ? defaultFilterValue : {}}
      toolbar={<ECreateToolbar initValues={initValues} />} // ✅ Pass initValues to the toolbar
      redirect={redirect}
    >
{/*         <DebugErrors />
 */}
      <Grid container sx={{ flexGrow: 1 }} spacing={2}>
        {resourcesTabs.map((t, index) => {
          if (filteredFields[index] && filteredFields[index].length > 0) {

            return (
              <Grid
                {...props}
                item
                size={{
                  xs: parseInt(t.width_class, 10),
                  sm: parseInt(t.width_class, 10)
                }}
                key={index}
              >

                <Typography variant="h6" gutterBottom>
                  {t.tab}
                </Typography>

                {renderFields(props, filteredFields[index], translate, resource)}
              </Grid>
            );
          }
          return null;
        })}
      </Grid>
    </SimpleForm>
  );
};


const UiSimpleForm = ({ canDelete, initValues = {}, resourcePermistions, resourcesFields, ...props }) => {
  const record = useRecordContext();
  // Merge record with initValues, prioritizing record values
  const dataSource = { ...initValues, ...record };

  const filteredFields = resourcesFields.map(
    (modelFields) =>
      modelFields &&
      modelFields.filter((f) => {
        if (
          f.workflow_info &&
          f.workflow_info.workflow_conditional === true &&
          dataSource &&
          dataSource[f.workflow_info.workflow_column]
        ) {
          const workflowColumn = f.workflow_info.workflow_column;
          const workflowConditionalShow = f.workflow_info.workflow_conditional_show
            .split(',')
            .map(Number);
          const workflowConditionalReadonly = f.workflow_info.workflow_conditional_readonly
            .split(',')
            .map(Number);

          if (
            dataSource[workflowColumn] &&
            workflowConditionalShow.includes(dataSource[workflowColumn])
          ) {
            if (
              dataSource[workflowColumn] &&
              workflowConditionalReadonly.includes(dataSource[workflowColumn])
            ) {
              f.input_widget_type =
                f.workflow_info.workflow_conditional_readonly_type;
            }
            return true;
          }
          return false;
        }
        return true;
      })
  );

  return (
    <Form
      filteredFields={filteredFields}
      toolbar={props.toolbar}
      initValues={initValues}  // ✅ Pass initValues to Form
      {...props}
    />
  );
};

export default UiSimpleForm
